var M = Object.defineProperty;
var U = (D, i, s) => i in D ? M(D, i, { enumerable: !0, configurable: !0, writable: !0, value: s }) : D[i] = s;
var C = (D, i, s) => U(D, typeof i != "symbol" ? i + "" : i, s);
import { E as q } from "./platform-components-assets/index-es2.js";
import { H as f, g as G, s as J, r as K, a as Q } from "./platform-components-assets/highlight-es.js";
import { N as y, u as V } from "./platform-components-assets/note-es.js";
import R from "./DomHelper.js";
import j from "./SelectionHelper.js";
const p = class p {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   */
  constructor(i) {
    C(this, "_clientId", null);
    C(this, "_domHelper", null);
    C(this, "_eventBus", null);
    this._clientId = p.getNextClientId(), this._eventBus = new q(), this._domHelper = new R({
      contextContainer: i == null ? void 0 : i.contextContainer,
      ignoredElements: i == null ? void 0 : i.ignoredElements,
      nodeSelectors: i == null ? void 0 : i.nodeSelectors
    }), p.add(this);
  }
  /**
   * The unique client ID of this instance.
   * @type {Number}
   * @readonly
   *
   * @example
   * const highlightHelper = new HighlightHelper();
   *
   * // prints the client-id
   * console.log(highlightHelper.clientId);
   *
   * // throws an exception
   * highlightHelper.clientId = 123;
   */
  get clientId() {
    return this._clientId;
  }
  /**
   * The context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   */
  get contextContainer() {
    return this.domHelper.contextContainer;
  }
  set contextContainer(i) {
    this.domHelper.contextContainer = i;
  }
  /**
   * The immediate parent of context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   * @readonly
   */
  get contextContainerParent() {
    var i;
    return ((i = this.contextContainer) == null ? void 0 : i.parentNode) || null;
  }
  /**
   * The {@link DomHelper} instance used by this selection.
   * @type {DomHelper}
   * @readonly
   */
  get domHelper() {
    return this._domHelper;
  }
  /**
   * The event bus for this instance.
   * @type {EventBus}
   * @readonly
   */
  get eventBus() {
    return this._eventBus;
  }
  /**
   * The array of ignored element selectors.
   * @type {String[]}
   */
  get ignoredElements() {
    return this.domHelper.ignoredElements;
  }
  set ignoredElements(i) {
    this.domHelper.ignoredElements = i;
  }
  /**
   * The node selectors data object.
   * @type {NodeSelectorsData}
   */
  get nodeSelectors() {
    return this.domHelper.nodeSelectors;
  }
  set nodeSelectors(i) {
    this.domHelper.nodeSelectors = i;
  }
  /**
   * Create a new highlight from the given save-state data and inject it into the DOM.
   * @param {Object} highlightData The highlight save-state data.
   * @returns {?Highlight} Returns a new instance of `Highlight` if successful, `null` otherwise.
   */
  createFromData(i) {
    const s = new f({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    return s.createFromData(i) ? s : null;
  }
  /**
   * Create or update the highlight with the given information.
   * WARNING: This method creates multiple axios requests in non-atomic operations.
   * TODO: Work with BE to make these operations atomic.
   * @param {SelectionHelper} selectionHelper The selection helper to use for creating/updating the highlight.
   * @param {String} color A valid highlight color string. See `Highlight.color` for details.
   * @param {Object} metadata The metadata related to the highlight.
   * @param {String} csrfToken The CSRF token to use with the API requests.
   * @returns {Promise} Returns a promise.
   */
  async createOrUpdate(i, s, l, r) {
    const a = p.state, {
      startNodeCompleteOverlap: c,
      startNodeHighlight: e,
      endNodeCompleteOverlap: H,
      endNodeHighlight: n,
      hasNotesInIntermediateHighlights: I,
      intermediateHighlights: S,
      combinedNotesText: x
    } = a, v = new j({
      ignoredElements: this.ignoredElements,
      contextContainer: this.contextContainer,
      nodeSelectors: this.nodeSelectors
    });
    v.updateSelection(i.selection);
    const { selection: h } = v;
    let g = null;
    I && (g = new y(), g.text = x), await f.batchDelete(S);
    const m = [...S], {
      promise: w,
      resolve: P,
      reject: b
    } = Promise.withResolvers(), F = async (t) => {
      t.note && !g && (g = new y(), g.text = x), await t.delete(), m.push(t);
    }, d = ({
      highlight: t,
      isNoop: o = !1,
      createdHighlights: u = [],
      updatedHighlights: L = []
    }) => {
      const B = t.save(
        r
      );
      return g && (t.note = g), B.then((E) => {
        P({
          createdHighlights: u,
          deletedHighlights: m,
          hasNewNote: !!g,
          highlight: t,
          isNoop: o,
          response: E,
          updatedHighlights: L
        });
      }).catch((E) => {
        b(E);
      }), w;
    };
    if (!e && !n) {
      const t = new f({
        ignoredElements: this.ignoredElements,
        contextContainer: this.contextContainer,
        nodeSelectors: this.nodeSelectors
      });
      return t.createFromSelection(
        v,
        s
      ) ? (t.metadata = l, d({
        highlight: t,
        createdHighlights: [
          t
        ]
      })) : (t.delete(), !1);
    }
    if (e && !n) {
      const t = e.getDataCamelCase();
      if (s === e.color || c)
        return t.node2 = h.endNodeSelector, t.offset2 = h.endOffset, t.color = s, e.updateFromData(t), d({
          highlight: e,
          updatedHighlights: [e]
        });
      t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r);
      const o = new f({
        ignoredElements: this.ignoredElements,
        contextContainer: this.contextContainer,
        nodeSelectors: this.nodeSelectors
      });
      return o.createFromData({
        node1: t.node2,
        offset1: t.offset2,
        node2: h.endNodeSelector,
        offset2: h.endOffset,
        color: s
      }), o.metadata = l, d({
        highlight: o,
        createdHighlights: [o],
        updatedHighlights: [e]
      });
    }
    if (!e && n) {
      const t = n.getDataCamelCase();
      if (s === n.color || H)
        return t.node1 = h.startNodeSelector, t.offset1 = h.startOffset, t.color = s, n.updateFromData(t), d({
          highlight: n,
          updatedHighlights: [n]
        });
      t.offset1 = h.endOffset, n.updateFromData(t), await n.save(r);
      const o = new f({
        ignoredElements: this.ignoredElements,
        contextContainer: this.contextContainer,
        nodeSelectors: this.nodeSelectors
      });
      return o.createFromData({
        node1: h.startNodeSelector,
        offset1: h.startOffset,
        node2: t.node1,
        offset2: t.offset1,
        color: s
      }), o.metadata = l, d({
        highlight: o,
        createdHighlights: [o],
        updatedHighlights: [n]
      });
    }
    if (e && n && e !== n) {
      const t = e.getDataCamelCase(), o = n.getDataCamelCase();
      if (!c && !H) {
        if (s !== e.color && s !== n.color) {
          t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r), o.offset1 = h.endOffset, n.updateFromData(o), await n.save(r);
          const u = new f({
            ignoredElements: this.ignoredElements,
            contextContainer: this.contextContainer,
            nodeSelectors: this.nodeSelectors
          });
          return u.createFromData({
            node1: t.node2,
            offset1: t.offset2,
            node2: o.node1,
            offset2: o.offset1,
            color: s
          }), u.metadata = l, d({
            highlight: u,
            createdHighlights: [u],
            updatedHighlights: [
              e,
              n
            ]
          });
        }
        if (s === e.color && e.color === n.color)
          return t.node2 = o.node2, t.offset2 = o.offset2, await F(n), e.updateFromData(t), d({
            highlight: e,
            updatedHighlights: [e]
          });
        if (s === e.color && e.color !== n.color)
          return o.offset1 = h.endOffset, n.updateFromData(o), await n.save(r), t.node2 = o.node1, t.offset2 = o.offset1, e.updateFromData(t), d({
            highlight: e,
            updatedHighlights: [
              e,
              n
            ]
          });
        if (s === n.color && e.color !== n.color)
          return t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r), o.node1 = t.node2, o.offset1 = t.offset2, n.updateFromData(o), d({
            highlight: n,
            updatedHighlights: [
              e,
              n
            ]
          });
      }
      if (c && !H)
        return s === n.color ? (t.node2 = o.node2, t.offset2 = o.offset2, await F(n), e.updateFromData(t), e.setColor(s), d({
          highlight: e,
          updatedHighlights: [e]
        })) : (o.offset1 = h.endOffset, n.updateFromData(o), await n.save(r), t.offset2 = h.endOffset, e.updateFromData(t), e.setColor(s), d({
          highlight: e,
          updatedHighlights: [
            e,
            n
          ]
        }));
      if (!c && H)
        return s === e.color ? (t.node2 = o.node2, t.offset2 = o.offset2, await F(n), e.updateFromData(t), e.setColor(s), d({
          highlight: e,
          updatedHighlights: [e]
        })) : (t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r), o.node1 = t.node2, o.offset1 = t.offset2, n.updateFromData(o), n.setColor(s), d({
          highlight: n,
          updatedHighlights: [
            e,
            n
          ]
        }));
      if (c && H)
        return t.node2 = o.node2, t.offset2 = o.offset2, await F(n), e.updateFromData(t), e.setColor(s), d({
          highlight: e,
          updatedHighlights: [e]
        });
    }
    if (e && e === n) {
      if (s === e.color)
        return P({
          isNoop: !0
        }), w;
      if (c && H)
        return e.setColor(s), d({
          highlight: e,
          updatedHighlights: [e]
        });
      const t = e.getDataCamelCase();
      if (c && !H) {
        const O = t.node1, A = t.offset1;
        t.offset1 = h.endOffset, e.updateFromData(t), await e.save(r);
        const N = new f({
          ignoredElements: this.ignoredElements,
          contextContainer: this.contextContainer,
          nodeSelectors: this.nodeSelectors
        });
        return N.createFromData({
          node1: O,
          offset1: A,
          node2: O,
          offset2: t.offset1,
          color: s
        }), N.metadata = l, d({
          highlight: N,
          createdHighlights: [N],
          updatedHighlights: [e]
        });
      }
      if (!c && H) {
        const O = t.node2, A = t.offset2;
        t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r);
        const N = new f({
          ignoredElements: this.ignoredElements,
          contextContainer: this.contextContainer,
          nodeSelectors: this.nodeSelectors
        });
        return N.createFromData({
          node1: O,
          offset1: t.offset2,
          node2: O,
          offset2: A,
          color: s
        }), N.metadata = l, d({
          highlight: N,
          createdHighlights: [N],
          updatedHighlights: [e]
        });
      }
      const o = t.offset2;
      t.offset2 = h.startOffset, e.updateFromData(t), await e.save(r);
      const u = new f({
        ignoredElements: this.ignoredElements,
        contextContainer: this.contextContainer,
        nodeSelectors: this.nodeSelectors
      }), L = h.endNodeSelector, B = h.endOffset;
      u.createFromData({
        node1: t.node2,
        offset1: t.offset2,
        node2: L,
        offset2: B,
        color: s
      }), u.metadata = l;
      const E = u.getDataCamelCase(), _ = new f({
        ignoredElements: this.ignoredElements,
        contextContainer: this.contextContainer,
        nodeSelectors: this.nodeSelectors
      });
      return _.createFromData({
        node1: E.node2,
        offset1: E.offset2,
        node2: E.node2,
        offset2: o,
        color: e.color
      }), _.metadata = l, await _.save(r), d({
        highlight: u,
        createdHighlights: [
          u,
          _
        ],
        updatedHighlights: [e]
      });
    }
    return b(), w;
  }
  /**
   * Dispatch an event on the event-bus.
   * @private
   * @param {String} eventName The name of the event to dispatch.
   * @param {Any} data The data to pass along into the event data.
   */
  _dispatchEvent(i, s) {
    this.eventBus.emit(
      i,
      {
        context: this,
        data: s
      }
    );
  }
  /**
   * Thist method is triggered on state-change from the singleton.
   * @private
   */
  _onStateChange(i, s) {
    this._dispatchEvent(
      "state:change",
      {
        state: i,
        previousState: s
      }
    );
  }
  /**
   * The API origin to use with the highlight-helper endpoints.
   */
  static get apiOrigin() {
    return G();
  }
  static set apiOrigin(i) {
    i && J(i);
  }
  /**
   * A map of the highlight-helpers currently available on the page. The keys are based on `clientId`.
   * @static
   * @readonly
   * @type {Map}
   */
  static get highlightHelpers() {
    return this._highlightHelpers;
  }
  static get selectionHelper() {
    return this._selectionHelper;
  }
  /**
   * The current state being tracked by the HighlightHelper class.
   * @readonly
   */
  static get state() {
    return this._state || (this._state = this.getDefaultState()), this._state;
  }
  /**
   * Registers the Highlight instance with the singleton for managing it better.
   * This also helps ensure we only attach event-listeners when there are active
   * instances on the page.
   * @param {HighlightHelper} highlightHelper An instance of the HighlightHelper.
   */
  static add(i) {
    this.highlightHelpers.set(
      i.clientId,
      i
    ), this.load();
  }
  /**
   * Adds event-listeners.
   * @private
   */
  static _addEventListeners() {
    this.selectionHelper.eventBus.on(
      "selection:change",
      this._onSelectionChange,
      this
    );
  }
  /**
   * Returns a default state object to be populated with the correct data.
   * @returns {Object} A default state object with empty or null values.
   */
  static getDefaultState() {
    return {
      startNodeHighlight: null,
      startNodeHighlightElement: null,
      startNodeCompleteOverlap: !1,
      startNodePartialOverlap: !1,
      endNodeHighlight: null,
      endNodeHighlightElement: null,
      endNodeCompleteOverlap: !1,
      endNodePartialOverlap: !1,
      intermediateHighlights: [],
      allHighlights: [],
      isExtendingHighlight: !1,
      combinedNotesText: null,
      hasNotesInIntermediateHighlights: !1,
      notes: [],
      selection: null
    };
  }
  /**
   * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
   * @returns {Number} A unique numeric client-id for the current window.
   */
  static getNextClientId() {
    const i = this._nextClientId;
    return this._nextClientId += 1, i;
  }
  /**
   * Loads and initializes the SelectionHelper singleton. This method can be safely
   * called multiple times as the internal checks ensure that the singleton initializes
   * just once.
   */
  static load() {
    this._isLoaded || (this._selectionHelper = new j(), this._state = this.getDefaultState(), this._addEventListeners(), this._isLoaded = !0);
  }
  /**
   * The event listener for `SelectionHelper`'s `selection:change` event.
   * @private
   * @param {Object} data The event data.
   */
  static _onSelectionChange(i) {
    const { selection: s } = i, {
      endNode: l,
      startNode: r
    } = s, a = this.getDefaultState(), c = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new Set();
    a.selection = s;
    const H = f.getHighlightFromNode(r);
    if (a.startNodeHighlight = H.highlight, a.startNodeHighlightElement = H.highlightElement, a.startNodeHighlight) {
      const g = a.startNodeHighlight.getHighlightElements().indexOf(a.startNodeHighlightElement) === 0;
      a.startNodeCompleteOverlap = s.startOffset === 0 && g, a.startNodePartialOverlap = !a.startNodeCompleteOverlap, c.add(a.startNodeHighlight), a.startNodeHighlight.note && e.add(a.startNodeHighlight.note);
    }
    const n = f.getHighlightFromNode(l);
    if (a.endNodeHighlight = n.highlight, a.endNodeHighlightElement = n.highlightElement, a.endNodeHighlight) {
      const h = a.endNodeHighlight.getHighlightElements(), g = h.length - 1, m = h.indexOf(a.endNodeHighlightElement) === g, w = a.endNodeHighlightElement.textContent.length;
      a.endNodeCompleteOverlap = s.endOffset === w && m, a.endNodePartialOverlap = !a.endNodeCompleteOverlap, c.add(a.endNodeHighlight), a.endNodeHighlight.note && e.add(a.endNodeHighlight.note);
    }
    const I = R.getIntermediateElementNodes(
      a.startNodeHighlightElement || r,
      a.endNodeHighlightElement || l
    ).filter((h) => h.classList.contains("de-highlight")), S = [];
    let x = !1;
    I.forEach((h) => {
      const g = parseInt(h.getAttribute("data-highlight-client-id"), 10), m = f.getByClientId(g);
      m === a.startNodeHighlight || m === a.endNodeHighlight || S.includes(m) || (S.push(m), c.add(m), m.note && (x = !0, e.add(m.note)));
    }), a.intermediateHighlights = S, a.allHighlights = Array.from(c), a.notes = Array.from(e), a.combinedNotesText = a.notes.map((h) => h.text).join(`

`), a.hasNotesInIntermediateHighlights = x, this.setState(a);
    const { activeHighlight: v } = f;
    if (s.text && v && v.deselect(), !s.text) {
      const h = a.startNodeHighlight;
      if (!h)
        return;
      h.select();
    }
  }
  /**
   * Unregisters the HighlighHelper instance with the singleton for managing it better.
   * This helps ensure we clean up any attached event-listeners after the last
   * instance has been removed from use on the page.
   * @param {Number} clientId The client-id of an instance of HighlightHelper.
   */
  static remove(i) {
    this.highlightHelpers.get(i) && (this.highlightHelpers.delete(i), this.highlightHelpers.size === 0 && this.unload());
  }
  /**
   * Removes event listeners.
   * @private
   */
  static _removeEventListeners() {
    this.selectionHelper.eventBus.off("selection:change", this._onSelectionChange);
  }
  /**
   * Get all highlights from the database.
   * @param {String} conceptId The concept GUID for retrieving the highlights.
   * @returns {Array} Returns an array of highlight data objects.
   */
  static async retrieveAllHighlights(i) {
    const s = await K(i), { highlights: l } = s.data;
    return await y.retrieveAllNotes(
      i,
      l
    ), l;
  }
  /**
   * Get all highlights from the database using references
   * @param {Array} references The concept GUID for retrieving the highlights.
   * @returns {Array} Returns an array of highlight data objects.
   */
  static retrieveAllHighlightsByReference(i) {
    return Q(i).then((s) => s.data.highlights);
  }
  /**
   * Updates the state of the highlights on the page.
   * @param {Object} state The state to override with.
   */
  static setState(i) {
    const s = {
      ...this._state
    }, l = {
      ...s,
      ...i
    };
    this._state = l, this.highlightHelpers.forEach((r) => {
      r._onStateChange(l, s);
    });
  }
  /**
   * Unloads the SelectionHelper singleton. This method can be safely called multiple times
   * as the internal checks ensure that the singleton unloads just once.
   */
  static unload() {
    this._isLoaded && (this._removeEventListeners(), this._selectionHelper.destroy(), this._selectionHelper = null, this._isLoaded = !1);
  }
  /**
   *
   * @param {String} noteId the ID for the note to be edited
   * @param {String} noteText the text that will update the note
   * @returns {Object} representing the response of the PATCH request for updated note
   */
  static updateNote(i, s) {
    return V(i, s).then((l) => l.data);
  }
};
// +===================================+
// | Static implementation starts here |
// +===================================+
C(p, "_highlightHelpers", /* @__PURE__ */ new Map()), C(p, "_isLoaded", !1), C(p, "_nextClientId", 1), C(p, "_selectionHelper", null), C(p, "_state", null);
let z = p;
export {
  z as default
};
